import React, { useState } from "react";
import { UpOutlined, DownOutlined } from "@ant-design/icons";

import {
  Content,
  WarningContainer,
  WarningTitle,
  WarningText,
  ScheduleContainer,
  ScheduleTitle,
  ScheduleTextContent,
  PhoneContainer,
  PhoneText,
  CollapseButton,
} from "./styles";

const SupportModule: React.FC = () => {
  const [isCollapsed, setIsCollapsed] = useState(true);

  return (
    <Content>
      <WarningContainer onClick={() => setIsCollapsed(!isCollapsed)}>
        <CollapseButton>
          {isCollapsed ? <DownOutlined /> : <UpOutlined />}
        </CollapseButton>
        <WarningTitle>Atenção</WarningTitle>
        <WarningText>
          Calculadora de Renda Variável será descontinuada após o vencimento do seu plano. Entre em contato para maiores informações.
        </WarningText>
      </WarningContainer>

      {!isCollapsed && (
        <>
          <ScheduleContainer>
            <ScheduleTitle>Horário de atendimento</ScheduleTitle>
            <ScheduleTextContent>
              Segunda a sexta-feira, das 8h às 19h, e sábado, das 9h às 15h.
            </ScheduleTextContent>
          </ScheduleContainer>

          <PhoneContainer>
            <PhoneText>
              <strong>3003 7293</strong> (Capitais e regiões metropolitanas)
            </PhoneText>
            <PhoneText>
              <strong>0800 800 0049</strong> (Demais localidades)
            </PhoneText>
          </PhoneContainer>
        </>
      )}
    </Content>
  );
};

export default SupportModule;
